import { inject } from "@angular/core";
import { environment } from '@sortenv/environment';
import { ILieferantenPortalEnvironment, ISortimentierenEnvironment } from "FoxxyInterfaces";
import { EnvironmentService, AuthService } from "FoxxyLib";
import { authConfig } from "./oauth.config";


export function intializeApp(): Promise<any> {

  const environmentService = inject(EnvironmentService<ISortimentierenEnvironment>) as EnvironmentService<ISortimentierenEnvironment>;

  const authService = inject(AuthService);

  return (async () => {




    try {
      const res = await fetch('./assets/config/config.json');
      const configuration = await res.json();
      authConfig.issuer = configuration['AuthIssuer'];
      if (authConfig.issuer == undefined) {
        throw new Error('AuthIssuer not defined for SSO');
      }

      environment.connections.SettingService = configuration['SettingService']?.toString();
      environment.connections.AdvWebapi = configuration['AdvWebapi']?.toString();
      environment.connections.CommonWebApi = configuration['CommonWebApi']?.toString();
      environment.connections.ADVSortimentWebapi = configuration['ADVSortimentWebapi']?.toString();
      environment.connections.KatalogWebapi = configuration['KatalogWebapi']?.toString();
      
      environment.connections.DocumentService = configuration['DocumentService']?.toString();
      environment.connections.SignalService = configuration['SignalService']?.toString();
      environment.connections.MediatipService = configuration['MediatipService']?.toString();
      environment.connections.UserService = configuration['UserService']?.toString();
      environment.connections.LDVService = configuration['LDVService']?.toString();
      environment.connections.TaskListService = configuration["TaskListService"]?.toString();

      environment.moebelEditorUrl = configuration['moebelEditorUrl']?.toString();
      environment.planogrammServiceUrl = configuration['planogrammServiceUrl']?.toString();
      environment.lieferantenPortalUrl = configuration['lieferantenPortalUrl']?.toString();
      environment.production = environment.production;

      environment.graphQLUrlSortimentieren = configuration['graphQLUrlSortimentieren']?.toString();

      environment.elasticSearchUrl = configuration["ElasticSearchUrl"]?.toString();

      environment.FeatureToggle = configuration['FeatureToggle'] ?? [];

      environment.olaServiceUrl = configuration["olaServiceUrl"]?.toString();

      environment.dispolistUrl = configuration["dispolistUrl"]?.toString(); 
      
      environment.FisSnippet = configuration["FisSnippet"]?.toString();

      environment.admins = configuration['admins'];
      environment.managers = configuration['managers'];

      environment.mandant = configuration['mandant'];
      environment.wups = configuration['wups'];



      return environment as ISortimentierenEnvironment;
    } catch (error) {
      console.error(error);

    }
  })().then((e) => {


    environmentService.environment = e;
    environmentService.authConfig = authConfig;

    authService.start();


  });




};
